const baseStyle = {
  _focus: {
    boxShadow: 'none'
  }
};

export default {
  baseStyle
} as const;
